module.exports = __webpack_public_path__ + "static/media/btn-edit-textinput.c3c5ce6d.svg";